import React from 'react'
import { Signup as SignUpComponent } from '../components'

function Signup() {
  return (
    <div>
        <SignUpComponent/>
    </div>
  )
}

export default Signup
